module.exports = function getResource(label, vars = []) {
    const resources = {
        storeHours: 'Horaires du magasin',
        storeClosed: 'Magasin fermé',
        openUntil: `Ouvert jusqu'à ${vars[0]} aujourd'hui`,
        tempClosed: 'Magasin temporairement fermé',
        tempUnavailable: 'Temporairement indisponible',
        curbsideHours: 'Heures de ramassage sur le trottoir',
        availableUntil: `Disponible jusqu'à ${vars[0]} aujourd'hui`,
        unavailable: 'Indisponible',
        specialCurbsideHours: 'Heures spéciales de ramassage sur le trottoir',
        specialStoreHours: 'Horaires spéciaux du magasin',
        available: 'Disponible',
        specialOpenUntil: `Ouvert jusqu'à ${vars[0]}`,
        kohlMessage: 'Les promotions, récompenses, services et événements Sephora peuvent ne pas s\'appliquer chez Kohl\'s'
    };

    return resources[label];
};
